import makeHttpRequest from '../helpers/ajax';
import wwwUrlEnv from '../helpers/www-url-env';
import makecollectionHttpRequest from '../helpers/ajax-cache-collection-response';
import appStorage from '../helpers/app-storage';

const lenderDescription = {};
let updateParentLenderDetail;
const requestData = (url, storageKey) => {
    const request = {
        url,
        expTime: 15 * 60 * 1000,
        storageKey,
        headers: {
            'x-requested-with': 'XMLHttpRequest',
        },
    };
    return request;
};

export default {
    data() {
        return {
            CachedData: {},
        };
    },
    getEnv() {
        return WP_LENDER_API_URL;
    },
    getLenderAPIPassKey() {
        return WP_LENDER_API_PASS_KEY;
    },
    makeAPICall(request) {
        return makeHttpRequest(request).then((response) => {
            const json = JSON.parse(response);
            if (json && json.lender && json.lender.lenderURlSuffix) return wwwUrlEnv.getWWWURL() + json.lender.lenderURlSuffix;
            return true;
        }, () => {
            console.warn('There is some issue with network call, please try again.');
        });
    },
    getAPIurl() {
        return this.getEnv();
    },
    getDetailsByLenderID(lenderId) {
        let url;
        let storageKey;

        if (lenderId && lenderId.toString().length > 0) {
            storageKey = `LenderDetailsByLenderID_${lenderId}`;
            url = `${this.getAPIurl() + lenderId}/${this.getLenderAPIPassKey()}`;
            const request = requestData(url, storageKey);
            return this.makeAPICall(request);
        }
        return false;
    },
    getDetailsByLendercode(lendercode) {
        let url;
        let storageKey;
        if (lendercode && lendercode.toString().length > 0) {
            storageKey = `LenderDetailsByLendercode_${lendercode}`;
            url = `${this.getAPIurl()}lendercode/${lendercode}/${this.getLenderAPIPassKey()}`;
            const request = requestData(url, storageKey);
            return this.makeAPICall(request);
        }
        return false;
    },
    GetLenderReviewDetails(lenderId, callBackFunction) {
        if (typeof callBackFunction != 'function') return;
        let url;
        this.callBackFunction = callBackFunction;
        if (lenderId && lenderId.toString().length > 1) {
            url = `${this.getAPIurl() + lenderId}/${this.getLenderAPIPassKey()}`;
            makeHttpRequest({ url }).then(response => this.callBackFunction(JSON.parse(response)), () => {
                console.warn('There is some issue with network call, please try again.');
            });
        }
    },
    getLenderDetails(lenderId) {
        let url;
        let storageKey;
        if (lenderId && lenderId.toString().length > 1) {
            url = `${this.getAPIurl() + lenderId}/${this.getLenderAPIPassKey()}`;
            storageKey = `LenderDetails_${lenderId}`;
            const request = requestData(url, storageKey);

            return makeHttpRequest(request).then(response => Promise.resolve(JSON.parse(response)), () => {
                console.warn('There is some issue with network call, please try again.');
            });
        }
        return false;
    },
    getLenderDescription(lenderId) {
        const lenderData = lenderDescription[lenderId];
        if (lenderData && lenderData.length > 0) {
            return;
        }

        let url;
        let storageKey;
        if (lenderId && lenderId.toString().length > 0) {
            url = `${this.getAPIurl() + lenderId}/${this.getLenderAPIPassKey()}`;
            storageKey = `LenderDescription_${lenderId}`;
            const request = requestData(url, storageKey);

            makeHttpRequest(request).then((response) => {
                const lenderDescriptionResponse = JSON.parse(response);
                if (lenderDescriptionResponse != null) {
                    lenderDescription[lenderId] = lenderDescriptionResponse;
                }
            }, () => {
                lenderDescription[lenderId] = null;
                console.warn('There is some issue with network call, please try again.');
            });
        }
    },
    lenderList() {
        return lenderDescription;
    },
    getLenderDetailsAPIurl() {
        return `${this.getEnv()}${this.getLenderAPIPassKey()}?lenderIds=`;
    },
    getLenderDetailsList(lenders, callBackFunction) {
        const options = {};
        const lenderIDs = [];
        const requestedLenders = [];
        for (let i = 0; i < lenders.length; i++) {
            const lenderId = lenders[i].LenderId;
            if (lenderIDs.indexOf(lenderId) < 0) {
                lenderIDs.push(lenderId);
            }
        }
        updateParentLenderDetail = callBackFunction;
        options.list = lenderIDs;
        options.url = this.getLenderDetailsAPIurl();
        options.storageKey = 'OfferDetails';
        options.callbackFunction = this.updateLenderDetails;
        options.expireTime = 60 * 60 * 1000;
        this.CachedData = {};

        for (let i = 0; i < options.list.length; i++) {
            const lender = options.list[i];
            const storageKey = `${options.storageKey}_${lender}`;

            if (storageKey) {
                const storageData = appStorage.get(storageKey);
                if (storageData !== null) {
                    this.CachedData[lender] = storageData;
                } else {
                    requestedLenders.push(lender);
                }
            }
        }
        if (requestedLenders.length > 0) {
            options.url += requestedLenders.join();
            makecollectionHttpRequest(options);
        }
        if (this.CachedData) {
            Object.keys(this.CachedData).forEach((key) => {
                const lender = this.CachedData[key];
                updateParentLenderDetail(lender);
            });
        }
    },
    updateLenderDetails(response) {
        for (let i = 0; i < response.length; i++) {
            const lender = response[i];
            updateParentLenderDetail(lender);
        }
    },
};
